{
  "modal": {
    "header": "Mapped to"
  },
  "company_industry": "Company Industry",
  "choose_internal_industries": "Choose internal industries to map to",
  "select_internal_industries_placeholder": "Select internal industries",
  "page": {
    "description": "Map our industry preferences to your custom internal industry list.",
    "internal_industry_button": "Internal Industry"
  },
  "table": {
    "headers": {
      "industry": "Industry",
      "added_at": "Added At",
      "mapped_to": "Mapped to",
      "actions": "Actions"
    }
  },
  "actions": {
    "map_tooltip": "Map",
    "view_companies_tooltip": "View Companies for this industry",
    "mapped_to_button": "Mapped To"
  },
  "filters": {
    "unmapped_industry": "Unmapped Industry"
  }
}
